module.exports = __webpack_public_path__ + "static/media/bg-term.284c1ca0.jpg";